<template>
  <div class="used-lower-default-content">
    <div class="used-seal">利用済</div>
  </div>
</template>

<script>
export default {
  name: "SFaceUsedLowerDefaultContent",
};
</script>

<style lang="scss" scoped>
.used-lower-default-content {
  background: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding-bottom: calc(6vh + 30px);
}

.used-seal {
  color: #d32f2f;
  font-size: 28px;
  font-weight: 700;
  border: 4px solid #d32f2f;
  border-radius: 8px;
  padding: 16px 40px;
}
</style>
